import React from 'react'
import { ThemeProvider, GlobalStyles } from '@mui/material'

import ThemeSettings from './components/theme/ThemeSettings'

const ThemeWrapper = ({ children }) => {
  const theme = ThemeSettings()
  return (
    <>
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            backgroundColor: '#1c2025'
          },
          '*': {
            boxSizing: 'border-box',
            '-ms-overflow-style': 'none'
          },
          '::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      />
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </>
  )
}

export default ThemeWrapper
